// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1Zt-g","tab":"ProcedureTabs_tab__8bqMB"};